import { render, staticRenderFns } from "./principleForm.vue?vue&type=template&id=7966fbec&scoped=true&"
import script from "./principleForm.vue?vue&type=script&lang=js&"
export * from "./principleForm.vue?vue&type=script&lang=js&"
import style0 from "./principleForm.vue?vue&type=style&index=0&id=7966fbec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7966fbec",
  null
  
)

export default component.exports